import React from 'react';
import './patient_partner_agreement.css';

export default function PatientPartnerAgreement() {
  return (
    <div className='container-fluid nopadding marg-top-for-transparent-header'>
      <div className='row'>
        <div className='col-sm-1'></div>
        <div className='col-sm-10'>
          <section className='terms-section'>
            <p>
              <b>Effective Date: 05/19/2026</b>
            </p>
            <h1>
              <b>MENTOR AGREEMENT</b>
            </h1>
            <p>
              <b>
                IMPORTANT – THIS IS A LEGAL AGREEMENT BETWEEN YOU (REFERENCED HEREIN WITH "Mentor", "you" OR WITH "your"
                OR "user") AND RIGHTDEVICE, INC. D/B/A PATIENTPARTNER (REFERENCED HEREIN AS "Rightdevice" OR
                "PatientPartner"). YOU SHOULD READ CAREFULLY THE FOLLOWING TERMS OF USE (REFERENCED HEREIN AS THE
                "Agreement") BECAUSE THEY GOVERN YOUR PARTICIPATION IN THE PATIENTPARTNER MENTOR PROGRAM OFFERED BY
                RIGHTDEVICE (REFERENCED HEREIN AS THE "Program"). RIGHTDEVICE IS WILLING TO GRANT YOU THE RIGHT TO
                PARTICIPATE IN THE PROGRAM ONLY ON THE CONDITION THAT YOU AGREE TO THE TERMS AND CONDITIONS SET FORTH IN
                THIS AGREEMENT. IF YOU DO NOT AGREE WITH ALL OF THE TERMS AND CONDITIONS SET FORTH IN THIS AGREEMENT,
                YOU ARE NOT GRANTED PERMISSION TO PARTICIPATE IN THE PROGRAM. BY CLICKING "I ACCEPT" AT THE END OF THIS
                AGREEMENT OR BY ACCESSING, PARTICIPATING OR USING ANY PORTION OF THE PROGRAM, YOU ACKNOWLEDGE THAT YOU
                HAVE READ THIS AGREEMENT, THAT YOU UNDERSTAND IT AND ITS TERMS AND CONDITIONS, AND THAT YOU AGREE TO BE
                BOUND LEGALLY BY IT AND ITS TERMS AND CONDITIONS.
              </b>
            </p>
            <p>
              You are electing to participate as a Mentor for the Program, a support and education program developed by
              Rightdevice. In so doing, you are prepared to fulfill the following responsibilities:
            </p>
            <ul>
              <li>Answer Mentee inquiries by sharing your personal story with others.</li>
              <li>
                Embody the Rightdevice mission to the best of your ability by providing hope and support to Mentees
                suffering from various health conditions.
              </li>
              <li>
                Complete the Mentor training before engaging with any Mentee, to follow all guardrails, communication
                guidelines, and escalation procedures covered in that training, and to complete any refresher,
                supplemental, or updated training that Rightdevice provides from time to time as a condition of
                continued participation.
              </li>
            </ul>
            <p>
              A "Mentee" is an individual who is researching, considering, preparing for, undergoing, or recovering from
              a medical procedure, treatment, or health condition, or a family member or caregiver acting on behalf of
              such individual, who is connected with you through the Program for peer support purposes.
            </p>
            <p>
              As a Mentor, you acknowledge and understand the following guidelines and will communicate these key points
              when communicating with Mentees:
            </p>
            <ul>
              <li>
                You are not a medical or other relevant health care professional and therefore CANNOT provide medical
                advice, opinions, diagnoses, or recommendations (whether clinical or otherwise).
              </li>
              <li>You can only speak on behalf of your personal and non-professional experiences.</li>
              <li>You are here to support and assist incoming Mentee inquiries.</li>
            </ul>
            <p>
              Not all treatment outcomes and experiences are the same and you agree that you will not provide specific
              product/treatment recommendations to Mentees while participating in the Program or on the PatientPartner
              website, but may refer them to consult with their licensed healthcare provider.
            </p>
            <p>
              You agree to allow the Rightdevice team to store your personal phone number and email address strictly for
              the purpose of the Program. You also understand that your personal contact information will not be
              published by Rightdevice and will not be sold or solicited, used outside of the purposes of the Program,
              except as described in the Rightdevice Privacy Policy.
            </p>
            <p>
              <b>LICENSE GRANT.</b>
            </p>
            <p>
              Subject to your continued compliance with this Agreement, Rightdevice provides to you a personal,
              revocable, limited, non-exclusive, non-transferable, and non-sublicensable license to access and use
              materials provided by Rightdevice for the Program including the right to access the Rightdevice website
              (the "Program Website"), and make single copies or prints of the content, information and materials
              provided to you through the Program (the "Program Materials") for your personal use only as a Mentor and
              that Rightdevice has the right to control and direct the means, manner, and method by which the Program is
              provided.
            </p>
            <p>
              <b>PARTICIPATION REQUIREMENTS.</b>
            </p>
            <p>
              In order to participate in the Program, Rightdevice requires that you provide certain information and
              fully complete the registration and submission procedures that Rightdevice requests in its sole
              discretion, in order to create an account on the Program Website. Upon completing any registration forms
              provided by Rightdevice, Rightdevice will provide a confirmatory e-mail (or other communication) notifying
              you of whether or not your registration has been approved. Rightdevice may deny your participation in the
              Program in its sole discretion including without limitation if your registration, expressions of consent,
              or submitted information do not meet Rightdevice's requirements or otherwise violate the terms and
              conditions of this Agreement. By filling out a registration or submission form and/or participating in the
              Program, you represent that you have the right, power, and authority (including being of the legal age of
              majority) to enter into an agreement with Rightdevice and fulfill your obligations under this Agreement
              and that you agree to abide by all applicable local, state, national laws and regulations with respect to
              your participation in the Program. You covenant or represent and warrant that (i) you will at all times
              provide true, accurate, current, and complete information when submitting information to Rightdevice in
              connection to the Program or when interacting with Mentees; and (ii) you will at all times comply with the
              terms and conditions of this Agreement and any other terms and conditions for participation in the Program
              or for access to or use of its associated tools, resources, or materials. You further represent that you
              will act in a manner that does not cause disruption of any Program event, interaction with Mentees or in a
              manner that interferes with any other individual's participation in the Program. While Rightdevice has
              endeavored to create a secure and reliable Program Website, you should understand that the confidentiality
              of any communication or material transmitted to/from the Program Website over the internet or other form
              of the global communication network cannot be guaranteed.
            </p>
            <p>
              <b>RESTRICTIONS ON USE.</b>
            </p>
            <p>
              All rights not expressly granted under this Agreement are hereby reserved to Rightdevice. Accordingly, you
              are hereby prohibited from participating in the Program in any manner that is not expressly and
              unambiguously authorized by this Agreement. You, therefore, may not modify, reproduce, duplicate, copy,
              download, store, further transmit, disseminate, transfer, disassemble, broadcast, publish, remove or alter
              any proprietary notices or labels, license, sublicense, sell, mirror, frame, rent, lease, private label,
              grant a security interest in, create derivative works of, or otherwise exploit the Program, Program
              Website and Program Materials, or any portion of the Program Website and Program Materials without
              Rightdevice's prior written consent except as expressly and unambiguously authorized herein.
            </p>
            <p>
              <b>NO MEDICAL ADVICE</b>
            </p>
            <p>
              As a condition of participating as a Mentor in the Program, you acknowledge and agree to the following:
            </p>
            <ul>
              <li>
                <b>No Medical Advice:</b> You will not provide medical advice, clinical guidance, diagnosis, treatment
                recommendations, or other health care services to any Mentee or participant. Your role is limited to
                sharing your personal experience and providing peer support only.
              </li>
              <li>
                <b>Encouragement to Seek Professional Care:</b> You will encourage Mentees to seek the advice of a
                qualified health care professional for any questions regarding medical conditions, symptoms, diagnoses,
                or treatment decisions. You will not discourage any Mentee from seeking or following professional
                medical advice.
              </li>
              <li>
                <b>Personal Experience Only:</b> You understand and agree that you may speak only about your own lived
                experience. You will not represent yourself as a medical professional or as acting on behalf of
                Rightdevice, or any health care provider, sponsor, or partner.
              </li>
              <li>
                <b>No Professional Relationship:</b> Your participation as a Mentor does not create a provider–patient
                relationship, therapist–client relationship, or any other professional health care relationship between
                you and any participant.
              </li>
              <li>
                <b>Compliance with Program Guidelines:</b> You agree to comply with all Program policies, training
                materials, and communication guidelines regarding appropriate interactions with Mentees and
                participants.
              </li>
            </ul>
            <p>
              You acknowledge that the Program is intended for informational and peer support purposes only and is not a
              substitute for professional medical advice, diagnosis, or treatment.
            </p>
            <p>
              <b>LINKS TO OTHER SITES</b>
            </p>
            <p>
              The Program Website may connect to certain third-party websites or online networks (collectively, "Third
              Party Sites"). These Third-Party Sites have not necessarily been reviewed by Rightdevice and are owned,
              controlled, and/or maintained solely by third parties over whom Rightdevice exercises no control. Your
              correspondence or any other dealings with third parties found through any Third-Party Site on the Program
              Website is solely between you and such third party. Accordingly, Rightdevice hereby expressly disclaims
              and shall not have any liability or responsibility for any Third-Party Sites.
            </p>
            <p>
              <b>MOBILE SERVICES</b>
            </p>
            <p>
              The Program may offer you various tools that are available to you via your mobile phone or other mobile
              computing devices (collectively, "Mobile Services"). Please note that your mobile carrier's normal
              messaging, data, and other rates and fees will apply to your use of the Mobile Services. In addition,
              downloading, installing, or using certain Mobile Services may be prohibited or restricted by your mobile
              carrier, and not all Mobile Services may work with all carriers or devices or in all locations. Therefore,
              you are solely responsible for checking with your mobile carrier to determine if the Mobile Services are
              available for your mobile devices; what restrictions, if any, may be applicable to your use of the Mobile
              Services; and how much such use will cost you. Nevertheless, all use of the Program, the Program Website
              and its related Mobile Services shall be strictly in accordance with this Agreement. Some features of the
              Mobile Services make use of detailed location and route information, for example in the form of GPS
              signals and other information sent by your mobile device on which the Mobile Services are used, installed
              and activated. These features cannot be provided without utilizing this technology.
            </p>
            <p>
              <b>FEEDBACK AND SUBMISSIONS.</b>
            </p>
            <p>
              Rightdevice welcomes your feedback and suggestions about Rightdevice's products and services, or with
              respect to how to improve the Program, your feedback and communications with Mentees and your Submissions
              (as defined below). By providing any suggestions, information, material, communications or other content
              (collectively, "Feedback") to Rightdevice or a Mentee, you represent and warrant that Feedback does not
              infringe or violate the intellectual property or proprietary rights of any third party (including, without
              limitation, patents, copyrights, or trademark rights) and that you have all rights necessary to convey to
              Rightdevice and enable Rightdevice to use such Feedback and integrate it into the Program. It is agreed
              that Rightdevice owns all Feedback and anonymized metadata and data that is either not identifiable to
              Mentor or made not identifiable by modification (each and collectively "Anonymized Data"), and any
              original forms or modifications thereof, and that Rightdevice may input into or use as input Feedback and
              Anonymized Data into machine learning and artificial intelligence models into or for the benefit of
              Rightdevice, and Rightdevice's customers, as well as its platforms and software. In addition, with respect
              to any Feedback and Anonymized Data, to the extent not owned by Rightdevice, you hereby grant to
              Rightdevice a royalty-free, perpetual, irrevocable, assignable, transferable, non-exclusive right and
              license for Rightdevice to adopt, publish, reproduce, disseminate, transmit, distribute, copy, use, create
              Feedback, Anonymized Data and any derivative works, and display (in whole or in part) worldwide, or act on
              such Feedback or Anonymized Data without additional approval or consideration, in any form, media, or
              technology now known or later developed for the full term of any rights that may exist in such content,
              and you hereby waive any claim to the contrary.
            </p>
            <p>
              <b>PROPRIETARY RIGHTS.</b>
            </p>
            <p>
              This Agreement provides only a limited right to access and use the Program Materials and the Program
              Website in accordance with the terms of this Agreement. Accordingly, you hereby agree that Rightdevice
              transfers no ownership or intellectual property interest or title in and to the Program Materials, the
              Program Website or any other Rightdevice intellectual property to you or anyone else in connection with
              your participation in the Program. All text, graphics, user interfaces, visual interfaces, photographs,
              sounds, artwork, computer code (including html code), programs, software, algorithms, products,
              information, and documentation as well as the design, structure, selection, coordination, expression,
              "look and feel," Anonymized Data and input and outputs into machine learning and artificial intelligence
              models, and arrangement of any content contained on or available through the Program Website are
              exclusively owned, controlled, and/or licensed by Rightdevice, Inc. d/b/a PatientPartner or its
              licensor(s) or affiliate(s). RIGHTDEVICE™, PatientPartner™ and all other marks identifying the products
              or services of Rightdevice are proprietary trademarks of Rightdevice, Inc. d/b/a PatientPartner, and any
              use of such marks, including, without limitation, as domain names, account identifiers, or in connection
              with any search engine optimization practice(s), without the prior express written permission of
              Rightdevice is hereby strictly prohibited.
            </p>
            <p>
              <b>PRIVACY POLICY.</b>
            </p>
            <p>
              Participation in the Program and access through the Program Website may require you to submit certain
              personally identifiable information. As a result, you agree to comply with the Privacy Policy contained
              herein and located at{' '}
              <a style={{ color: 'black', fontSize: '14px' }} href='https://www.patientpartner.com/privacy'>
                https://www.patientpartner.com/privacy
              </a>
            </p>
            <p>
              <b>DISCLAIMER.</b>
            </p>
            <p>
              THE PROGRAM, PROGRAM MATERIALS AND PROGRAM WEBSITE ARE PROVIDED ON AN "AS-IS" BASIS AND MAY INCLUDE
              ERRORS, OMISSIONS, OR OTHER INACCURACIES. RIGHTDEVICE HEREBY EXPRESSLY DISCLAIMS ALL WARRANTIES, EXPRESS
              OR IMPLIED, INCLUDING, WITHOUT LIMITATION, ANY WARRANTY OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
              PURPOSE, OR NON-INFRINGEMENT OR ANY OTHER IMPLIED WARRANTY UNDER THE UNIFORM COMPUTER INFORMATION
              TRANSACTIONS ACT AS ENACTED BY ANY STATE. RIGHTDEVICE ALSO MAKES NO REPRESENTATIONS OR WARRANTIES THAT THE
              PROGRAM, PROGRAM MATERIALS AND PROGRAM WEBSITE WILL OPERATE ERROR-FREE, UNINTERRUPTED, OR IN A MANNER THAT
              WILL MEET YOUR PARTICULAR REQUIREMENTS AND/OR NEEDS. THEREFORE, YOU ASSUME THE ENTIRE RISK REGARDING THE
              QUALITY AND/OR PERFORMANCE OF THE PROGRAM, PROGRAM MATERIALS AND PROGRAM WEBSITE.
            </p>
            <p>
              <b>LIMITATION OF LIABILITY.</b>
            </p>
            <p>
              YOU AGREE THAT IN NO EVENT SHALL RIGHTDEVICE BE LIABLE FOR ANY INDIRECT, PUNITIVE, INCIDENTAL, SPECIAL, OR
              CONSEQUENTIAL DAMAGES ARISING OUT OF OR IN ANY WAY CONNECTED WITH PARTICIPATION IN OR THE USE OF THE
              PROGRAM BY YOU OR ANYONE ELSE, WHETHER BASED IN CONTRACT, TORT, STRICT LIABILITY, OR OTHERWISE, EVEN IF
              RIGHTDEVICE HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. YOU ALSO ACKNOWLEDGE AND AGREE THAT
              RIGHTDEVICE SHALL NOT BE RESPONSIBLE FOR ANY FAILURES, INOPERABILITY, DELAYS, OR PROBLEMS CAUSED BY YOUR
              FAILURE TO PROVIDE OR OBTAIN THE NECESSARY RIGHTS CLEARANCE FOR ANY INFORMATION YOU SUBMIT TO THE PROGRAM
              IN A TIMELY OR ACCURATE MANNER. MOREOVER, RIGHTDEVICE ASSUMES NO RESPONSIBILITY FOR THE DELETION OF OR
              FAILURE TO STORE ANY CONTENT OR INFORMATION. WITHOUT LIMITATION OF THE FOREGOING, EXCEPT AS OTHERWISE SET
              FORTH IN APPLICABLE STATE AND FEDERAL LAW, THE TOTAL LIABILITY OF RIGHTDEVICE FOR ANY REASON WHATSOEVER
              RELATED TO PARTICIPATION OR USE OF THE PROGRAM OR FOR ANY CLAIMS RELATING TO THIS AGREEMENT SHALL NOT
              EXCEED $500 (USD).
            </p>
            <p>
              <b>INDEMNIFICATION.</b>
            </p>
            <p>
              To the fullest extent permitted by applicable law, you agree to defend, indemnify, and hold harmless
              Rightdevice, its affiliates, and their respective officers, directors, employees, agents, and licensors
              (collectively, the "Indemnified Parties") from and against any and all claims, demands, suits, actions,
              proceedings, losses, damages, liabilities, costs, and expenses (including reasonable attorneys' fees)
              arising out of or related to: (i) your breach of any representation, warranty, or obligation under this
              Agreement; (ii) your provision of medical advice, clinical guidance, diagnosis, or treatment
              recommendations to any Mentee or other participants; (iii) any statement made by you to a Mentee or other
              participant that is false, misleading, defamatory, or otherwise unlawful; (iv) your misrepresentation of
              your relationship with Rightdevice, or any health care provider, sponsor, or partner; (v) your violation
              of any applicable law, regulation, or third-party right (including any intellectual property right or
              right of privacy); or (vi) any harm alleged to have been caused to a Mentee or other person as a result of
              your acts or omissions in connection with the Program. Rightdevice reserves the right, at its own expense,
              to assume the exclusive defense and control of any matter otherwise subject to indemnification by you, in
              which event you will cooperate with Rightdevice in asserting any available defenses.
            </p>
            <p>
              <b>CONFIDENTIALITY.</b>
            </p>
            <p>
              In the course of your participation as a Mentor, you may receive or have access to non-public information
              about Mentees, other Mentors, or Rightdevice, including health information, personal contact information,
              treatment histories, and program materials (collectively, "Confidential Information"). You agree that you
              will: (i) hold all Confidential Information in strict confidence and use it only for the purpose of
              fulfilling your responsibilities under this Agreement; (ii) not disclose any Confidential Information to
              any third party, including family members, friends, employers, or any media or social media platform,
              without the prior written consent of Rightdevice; (iii) not record, screenshot, store, copy, or retain any
              Confidential Information except as expressly authorized by Rightdevice; (iv) not contact any Mentee
              outside of the Program Website, platform, channels, or tools made available by Rightdevice, and not
              solicit or accept a Mentee's personal contact information for any purpose outside the Program; and (v)
              promptly notify Rightdevice in writing if you become aware of any actual or suspected unauthorized use or
              disclosure of Confidential Information. Your obligations under this section will survive any termination
              of this Agreement and will continue indefinitely.
            </p>
            <p>
              <b>INJUNCTIVE RELIEF.</b>
            </p>
            <p>
              You acknowledge that any breach, threatened or actual, of this Agreement, including, without limitation,
              violations or infringement of Rightdevice's intellectual property or proprietary rights, may cause
              irreparable injury to Rightdevice, whereby such injury would not be quantifiable in monetary damages, and
              Rightdevice would not have an adequate remedy at law. In the event of such injury or potential for such
              injury you therefore hereby agree that Rightdevice shall be entitled, in addition to other available
              remedies, to seek and be awarded an injunction or other appropriate equitable relief from a court of
              competent jurisdiction restraining any breach, threatened or actual, of your obligations under any
              provision of this Agreement.
            </p>
            <p>
              <b>THIRD-PARTY PRODUCTS/SERVICES.</b>
            </p>
            <p>
              Rightdevice, in its sole discretion, may feature and/or post the advertisements of third parties on the
              Program Materials or Program Website and/or feature on the Program Materials or Program Website,
              materials, programs, products, and services provided by third parties. Rightdevice makes no
              representations with respect to, nor does it guarantee or endorse, the quality, non-infringement,
              accuracy, completeness, timeliness, reliability, or correct sequencing of such third-party materials,
              programs, products, and services or any other materials, programs, products, and services which such
              third-party materials, products, and services may access. Your correspondence or any other dealings with
              third parties found on the Program Materials or Program Website are solely between you and such third
              party. Accordingly, Rightdevice expressly disclaims responsibility and liability for all third-party
              provided materials, programs, products, and services contained on or accessed through the Program
              Materials or Program Website, and you agree that Rightdevice shall not be responsible for any loss or
              damage of any sort incurred as a result of any such dealings or as the result of the presence of such
              third parties on the Program Materials or Program Website.
            </p>
            <p>
              <b>SECURITY &amp; ENFORCEMENT.</b>
            </p>
            <p>
              Rightdevice reserves the right in its sole discretion to review, monitor, and/or record any information
              relating to your use of the Program Website including without limitation any Feedback ("User Information")
              without any prior notice to or permission from you, including, without limitation, by archiving content
              and/or communications submitted to and/or sent by you through the Program Website. In addition to the
              rights granted to Rightdevice, Rightdevice may share any User Information we obtain from you with any law
              enforcement organization in connection with any investigation or prosecution of possible criminal or
              unlawful activity. Rightdevice will also disclose User Information as required by any court order and/or
              subpoena. In addition, Rightdevice hereby reserves the right, in its sole discretion and at any time
              without prior notice, to suspend, restrict, or terminate your access to the Program Website, or any
              portion thereof, in order to protect the Program Website, Rightdevice's intellectual property,
              Rightdevice, or the business interests of Rightdevice and/or its members and affiliates.
            </p>
            <p>
              <b>MATERIALS YOU POST OR PROVIDE; COMMUNICATION MONITORING</b>
            </p>
            <p>
              You may be able to post or submit reviews, comments, questions, direct messages, photographs, videos
              (including videos created through a third-party tool) and other materials on or through the Program
              Website (collectively, "Submission" or "Submissions"). Your Submissions, (including to the extent
              applicable personally identifiable information), are made voluntarily and are subject to Rightdevice's
              Code of Conduct (
              <a style={{ color: 'black', fontSize: '14px' }} href='https://patient.patientpartner.com/code-of-conduct'>
                https://patient.patientpartner.com/code-of-conduct
              </a>
              ) and Privacy Policy (
              <a style={{ color: 'black', fontSize: '14px' }} href='https://patient.patientpartner.com/privacy'>
                https://patient.patientpartner.com/privacy
              </a>
              ). You understand Rightdevice is not required to treat any of your Submissions as confidential. In
              addition, you understand and agree that your Submissions (including your username associated with your
              Submissions) are not confidential.
            </p>
            <p>
              You also grant Rightdevice the right and authority to send takedown notices (on your behalf) related to
              your Submission to any individual or entity under the Digital Millennium Copyright Act.
            </p>
            <p>Rightdevice will not pay you for your Submission.</p>
            <p>
              You also understand and agree that Rightdevice may, in its sole discretion, refuse, or remove part or all
              of your Submission from the Program website at any time if Rightdevice considers the Submission to be
              illegal, offensive, harassing, infringing, inappropriate or otherwise violates the terms of this Agreement
              or the Rightdevice Code of Conduct or other policies. For each Submission, you represent and warrant that
              you have all rights necessary for you to post or submit the Submission and to grant the licenses and
              permissions in this section and that you are solely responsible for the content of your Submission.
              Further, you represent and warrant that your Submission does not violate any law.
            </p>
            <p>
              Rightdevice reserves the right to review and monitor Submissions but is under no obligation to do so. In
              addition, Rightdevice is not responsible for screening, monitoring or editing Submissions. However, we may
              monitor your Submissions and may disclose information about you, including the contents of such
              Submission, if we deem it necessary to: (i) conform to legal requirements or respond to legal process;
              (ii) ensure your compliance with the terms of this Agreement or other Rightdevice guidelines or policies;
              or (iii) protect the rights, property, or interests of Rightdevice, its employees, its users, or the
              public. You acknowledge that Rightdevice may contact you by phone, email, or text message regarding your
              participation as a Mentor in the Program. Standard message and data charges from your mobile carrier may
              apply to any text messages.
            </p>
            <p>
              <b>GOVERNING LAW.</b>
            </p>
            <p>
              This Agreement has been made in and will be construed and enforced in accordance with the laws of the
              State of California as applied to agreements entered into and completely performed in the State of
              California. You agree to the personal jurisdiction by and venue in any federal or state court in the State
              of California, County of San Diego and waive any objection to such jurisdiction or venue and further to a
              jury trial in any action. You also acknowledge and agree that any applicable state law implementation of
              the Uniform Computer Information Transactions Act (including any available remedies or laws) shall not
              apply to this Agreement and is hereby disclaimed. Any claim you might have against Rightdevice must be
              brought within one (1) year after the cause of action arises, or such claim or cause of action is barred.
              In any legal proceeding brought by Rightdevice, Rightdevice shall have the right to seek and be awarded
              all reasonable attorneys' fees and costs in addition to any other relief, at law or in equity, to which
              Rightdevice may be entitled. A printed version of this Agreement and of any related notice given in
              electronic form shall be admissible in judicial or administrative proceedings based upon or relating to
              this Agreement to the same extent as other documents and records originally generated and maintained in
              printed form. Please print a copy of this Agreement or contact Rightdevice if you wish to receive a
              printed copy of this Agreement.
            </p>
            <p>
              <b>TERM AND TERMINATION.</b>
            </p>
            <p>
              This Agreement will take effect at the time you click or check "I ACCEPT", or begin using any part of the
              Program including the Program Materials and the Program Website, whichever is earliest. This Agreement
              will terminate automatically if (i) you fail to comply with any of its terms and conditions; or (ii) you
              cease all use of the Program. Termination will be effective without notice. In addition, Rightdevice may
              in its sole discretion terminate, modify, suspend, and/or interrupt operation of or access to this
              Agreement, the Program, the Program Materials, and the Program Website upon notice to you for any or no
              reason. Upon termination of this Agreement, any and all right(s) to participate in the Program and use the
              Program Materials and Program Website shall immediately cease and you must promptly delete or destroy all
              copies of the Program Materials and the Program Website in your possession or control. The following
              sections will survive any termination of this Agreement: Restrictions on Use, No Medical Advice, Feedback
              and Submissions, Proprietary Rights, Privacy Policy, Disclaimer, Limitation of Liability, Indemnification,
              Confidentiality, Injunctive Relief, Third-Party Products/Services, Security &amp; Enforcement, Materials
              You Post or Provide, Governing Law, Waiver &amp; Severability, Other Terms and Conditions, Miscellaneous,
              Media Release, and HIPAA Release.
            </p>
            <p>
              <b>WAIVER &amp; SEVERABILITY.</b>
            </p>
            <p>
              Rightdevice's failure to insist on upon strict performance of any of the terms and conditions of this
              Agreement by you will not operate as a waiver of any subsequent or other default or failure of
              performance. If any part of this Agreement is determined by a court of competent jurisdiction to be
              invalid or unenforceable pursuant to applicable law or court order including, but not limited to, the
              warranty disclaimers and the liability limitations set forth above, then the invalid or unenforceable
              provision will be deemed superseded by a valid, enforceable provision(s) that most clearly matches the
              intent of the original provision and the remainder of this Agreement shall continue in effect.
            </p>
            <p>
              <b>OTHER TERMS AND CONDITIONS.</b>
            </p>
            <p>
              Additional notices, terms, and conditions may apply to access to or use of Rightdevice's products and
              services. If there is a conflict between this Agreement and any other notices, terms, or conditions,
              Rightdevice shall resolve any conflict in good faith in its sole discretion but this Agreement shall
              generally control with respect to accessing, using, or participating in the Program.
            </p>
            <p>
              <b>MISCELLANEOUS.</b>
            </p>
            <p>
              These terms and the Mentor Consent Form (if applicable) provided to you constitute the entire Agreement
              between you and Rightdevice regarding your participation in the Program and supersedes any prior
              agreements between you and Rightdevice relating to your use of the Program Website and your participation
              as a Mentor in the Program. The failure of Rightdevice to exercise or enforce any right or provision of
              this Agreement shall not constitute a waiver of such right or provision in that or any other instance. No
              joint venture, partnership, employment, or agency relationship exists between you and Rightdevice as a
              result of this Agreement or your utilization of the Program. Headings are for convenience only. You may
              not assign, delegate, or transfer any rights under this Agreement without the prior express written
              consent of Rightdevice, which may be withheld in Rightdevice's sole discretion. Rightdevice may update
              these terms and conditions at any time by posting or sending you a revised version of the Agreement.
              Accordingly, please review the terms and conditions found at this location on a periodic basis. Each time
              you access the Program, you agree to be bound by the Agreement in effect at the time you use and
              participate in the Program. If you do not agree to the revised terms, do not use the Program.
            </p>
            <p>
              <b>MEDIA RELEASE</b>
            </p>
            <p>
              You hereby grant Rightdevice a perpetual, worldwide, and royalty-free license to use, display, publish,
              reproduce, distribute, and/or otherwise disseminate your name, likeness, photographic image, radiographic
              image, video image, and audio recording (collectively, "Name and Likeness") and any statement or
              endorsement you make about Rightdevice or your experience with its products or services, including,
              without limitation, the Program (collectively, "Testimonial"), in Rightdevice's promotional materials and
              publicity efforts, without further compensation or consideration to you. Any content and material using
              your Name and Likeness will be subjected to written authorization by you. You understand that your Name
              and Likeness and your Testimonial may be used in print and online publications and advertisements, product
              brochures, direct-mail pieces, television, newspapers, magazines, social media, and/or other forms of
              promotional and publicity efforts.
            </p>
            <p>
              You waive all rights of inspection, review, or approval with regard to your Name and Likeness and your
              Testimonial if the content remains unmodified from its original version.
            </p>
            <p>
              You hereby release and discharge Rightdevice from and shall neither sue nor bring any proceeding against
              Rightdevice for, any claim, demand, or cause of action, whether now known or unknown by you, for
              defamation, invasion of right to privacy, or right of publicity, or due to distortion, illusionary effect,
              or faulty reproduction, or arising out of or related to the use of your Name and Likeness or your
              Testimonial.
            </p>
            <p>
              Notwithstanding the foregoing, you agree Rightdevice is under no obligation to use your Name and Likeness
              or your Testimonial in any way.
            </p>
            <p>
              <b>HIPAA Release (Mentor Specific)</b>
            </p>
            <p>
              Completion of this document authorizes the disclosure and use of health information about you. Failure to
              provide all the information requested may invalidate this authorization.
            </p>
            <p>
              <b>USE AND DISCLOSURE OF HEALTH INFORMATION</b>
            </p>
            <p>
              You hereby authorize Rightdevice located at the address 1025 Prospect Street, Suite 350, La Jolla,
              California, 92037, the following information:
            </p>
            <p>
              Only the following records or types of current or historical health information (including any dates):
              Name, Date of Birth, Medical Procedure/Treatments, Established/Historical HCP, Contact Information,
              Height, Weight, Health Conditions, Date of Treatment, Symptoms, Comorbidities, and Other Relevant
              Healthcare Related Information.
            </p>
            <p>
              <b>PURPOSE</b>
            </p>
            <p>
              The purpose of the requested use or disclosure is for: To participate as a Mentor in the PatientPartner
              Mentor Program
            </p>
            <p>
              <b>YOUR RIGHTS</b>
            </p>
            <p>
              You may disagree to this authorization. Your refusal will not affect your ability to obtain treatment or
              payment or eligibility for benefits, but may affect your ability to participate as a Mentor in the
              Program.
            </p>
            <p>
              You may inspect or obtain a copy of the health information that you are being asked to allow the use or
              disclosure of.
            </p>
            <p>
              You may revoke this authorization at any time, but you must do so in writing and submit it to the
              following mailing address:
            </p>
            <p>
              Attn: Rightdevice, Inc. d/b/a PatientPartner
              <br />
              1025 Prospect Street, Suite 350
              <br />
              La Jolla, California, 92037
              <br />
              or via email: <a href='mailto:contact@patientpartner.com'>contact@patientpartner.com</a>.
            </p>
            <p>
              Your revocation will take effect upon receipt, except to the extent that others have acted in reliance
              upon this authorization.
            </p>
            <p>You have a right to receive a copy of this authorization.</p>
            <p>
              Information disclosed pursuant to this authorization could be redisclosed by the recipient. Such
              redisclosure is in some cases not prohibited by California law and may no longer be protected by federal
              confidentiality law (HIPAA). However, California law prohibits the person receiving your health
              information from making further disclosures of it unless another authorization is obtained from you or
              unless such disclosure is specifically required or permitted by law.
            </p>
            <p>
              <b>ACCEPTANCE AND SIGNATURE</b>
            </p>
            <p>
              By accessing or using the service or Program, or by clicking "submit" or a similar acknowledgment when
              creating an account or enrolling in the Program, you acknowledge that you have read this Agreement, that
              you understand it and its terms and conditions, and that you agree to be bound legally by it and its terms
              and conditions, including the Media Release and HIPAA Release set forth above. You confirm that you are at
              least eighteen (18) years of age and have the legal authority to enter into this Agreement.
            </p>
            <p>
              <b>Contact Us</b>
            </p>
            <p>
              If you have any questions about this Agreement, please contact us by email:{' '}
              <a href='mailto:contact@patientpartner.com'>contact@patientpartner.com</a>.
            </p>
          </section>
        </div>
        <div className='col-sm-1'></div>
      </div>
    </div>
  );
}
